import type { MainActionType, SubActionType } from '../components/Operation/MacroNestedPopover.vue'
import type { DraftRecordItem } from './useDraftDataManager'

/**
 * 将 UI 菜单事件映射成业务动作。
 */
export function useActionRouter(params: {
  onDelete: (record: DraftRecordItem, id?: string) => void
  onEdit: (record: DraftRecordItem, id?: string) => void
  onAddKey: (record: DraftRecordItem, id?: string) => void
  onAddDelay: (record: DraftRecordItem, id?: string) => void
  onAddCoordinate: (record: DraftRecordItem, id?: string) => void
}) {
  const { onDelete, onEdit, onAddKey, onAddDelay, onAddCoordinate } = params

  const routeMainAction = (type: MainActionType, record: DraftRecordItem, id?: string) => {
    if (type === 'delete') {
      onDelete(record, id)
      return
    }

    if (type === 'edit') {
      onEdit(record, id)
    }
  }

  const routeSubAction = (type: SubActionType, record: DraftRecordItem, id?: string) => {
    if (type === 'key') {
      onAddKey(record, id)
      return
    }

    if (type === 'delay') {
      onAddDelay(record, id)
      return
    }

    onAddCoordinate(record, id)
  }

  return {
    routeMainAction,
    routeSubAction,
  }
}
